import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { consumeShareToken } from "./features/profile-sharing/profileShares";

// After a new deploy, the service worker may replace its pre-cache while
// the page still holds old chunk references. A reload picks up the new
// HTML + new SW cache. A sessionStorage guard prevents infinite loops.
// See https://vite.dev/guide/build.html#load-error-handling
window.addEventListener("vite:preloadError", () => {
  const key = "chunk-reload";
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, "1");
    window.location.reload();
  }
});

const root = createRoot(document.getElementById("root")!);
let recipientActive = false;
let navigationVersion = 0;

function renderRoute() {
  if (location.hash.startsWith("#/shared-profile")) {
    recipientActive = true;
    const version = ++navigationVersion;
    const token = consumeShareToken();
    // Clear the old profile immediately, including its photos and pending reads.
    root.render(null);
    document.title = "Privately shared profile | Matchmakers Elite";
    void import("./features/profile-sharing/SharedProfilePage").then(
      ({ SharedProfilePage }) => {
        if (version !== navigationVersion) return;
        root.render(
          <StrictMode>
            <SharedProfilePage key={token} token={token} />
          </StrictMode>,
        );
      },
    );
  } else {
    recipientActive = false;
    const version = ++navigationVersion;
    void import("./App.tsx").then(({ default: App }) => {
      if (version !== navigationVersion) return;
      root.render(
        <StrictMode>
          <App />
        </StrictMode>,
      );
    });
  }
}
window.addEventListener("hashchange", () => {
  if (recipientActive || location.hash.startsWith("#/shared-profile"))
    renderRoute();
});
renderRoute();
